import appConfigCoverGoProd from "./appConfigCoverGoProd.js"
import { COVERGO_SAAS_PROD } from "../consts.js"

export const coverLibrary = {
	"studio.covergo.com": { appConfig: appConfigCoverGoProd, envConfig: COVERGO_SAAS_PROD },
	"coverLibrary-uat-studio.quote.hk": { appConfig: appConfigCoverGoProd, envConfig: COVERGO_SAAS_PROD }
}
